import initialState from './state.js';

export default {
    resetState(state) {
        Object.assign(state, initialState);
    },

    // APPOINTMENTS
    setAppointments(state, appointments) {
        state.appointments = appointments;
    },
    addAppointment(state, appointment) {
        const isSameDay = moment(appointment.datetime).isSame(state.selectedDate, 'day');

        if (!isSameDay || state.appointments.find(a => a.id == appointment.id)) {
            return;
        }

        state.appointments.push(appointment);
    },
    deleteAppointment(state, appointment) {
        state.appointments.splice(state.appointments.indexOf(appointment), 1);
    },
    updateAppointment(state, updatedAppointment) {
        if (!updatedAppointment.id) {
            return;
        }

        const appointment = state.appointments.find(a => a.id == updatedAppointment.id);

        if (!appointment) {
            return;
        }

        const isSameDay = moment(appointment.datetime).isSame(moment(updatedAppointment.datetime), 'day');

        if (updatedAppointment.datetime && !isSameDay) {
            state.appointments.splice(state.appointments.indexOf(appointment), 1);
            return;
        }

        Object.assign(appointment, updatedAppointment);
    },
    setSelectedDate(state, date) {
        state.selectedDate = date;
    },
    setSelectedAppointments(state, appointments) {
        state.selectedAppointments = appointments;
    },

    // IMPORTS
    setCurrentImport(state, currentImport) {
        state.currentImport = currentImport;
    },
    setPreviewRows(state, previewRows) {
        state.previewRows = previewRows;
    },
    setMatchedColumns(state, matchedColumns) {
        state.matchedColumns = matchedColumns;
    },
    setImportHistory(state, imports) {
        state.imports = imports;
    },
    deleteImport(state, importId) {
        state.imports.splice(
            state.imports.findIndex(i => i.id == importId),
            1,
        );
    },
};
